









import VueOptions from '@utils/VueOptions'
import ActivationPlanDisplay from './ActivationPlanDisplay'

settings =
  name: 'ActivationPlanOfferWrapper'

  vue:
    props: ['item', 'activationPlan', 'options']

    components: {
      ActivationPlanDisplay,
    }

export default VueOptions.vue settings
